import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=0bdfef4c&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=0bdfef4c&prod&lang=stylus&scoped=true"
import style1 from "./Index.vue?vue&type=style&index=1&id=0bdfef4c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdfef4c",
  null
  
)

export default component.exports